import { SvgIcon } from '@material-ui/core';
import { ReactComponent as gift } from './gift.svg';

export default function Gift(props) {
  return <SvgIcon {...props} component={gift} viewBox="0 0 154 156" />;
}
